module.exports = __webpack_public_path__ + "img/img_17.ec464b34.jpg";